module.exports = __webpack_public_path__ + "e8d1894a2273d6e4cd422113132eb500.gif";